import { useParams } from 'react-router-dom';

export const useRequiredParams = <P extends Record<string, string>>() => {
  const params = useParams<P>() as Partial<P>;

  for (const key in params) {
    if (!params[key]) {
      throw new Error(`Required parameter "${key}" is missing`);
    }
  }

  return params as P;
};
